// import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom'
import * as myconst from "../constants/index"
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { adminAnnouncements, adminAnnouncementsHover, adminBlackListed, adminBlackListedHover, adminBotConfiguration, adminBotConfigurationHover, adminConfiguration, adminConfigurationHover, adminDashboard, adminDashboardHover, adminDataCollector, adminDataCollectorHover, adminDocApproval, adminDocApprovalHover, adminFlag, adminFlagHover, adminUser, adminUserHover, sidebarDrawerArrow, ForecastConfigurationIcon, ForecastConfigurationHoverIcon, adminConversationHistoryHover, adminConversationHistory } from 'assets/icons';
import { setSelectedConnector } from 'redux/counterSlice';
import { permission } from 'services/permissionService';

const Sidebar = ({ isActive, setActive, sidebarRef, oh }: any) => {
    const location = useLocation()
    const dispatch = useDispatch()
    const temp = location.pathname.split('/').filter(entry => entry.trim() !== '');
    let featureFlag: any = JSON.parse(localStorage.getItem("feature-flag") || '{}');
    // const dashboardFlag = featureFlag[myconst.FEATURE_FLAG_KEY.dashboard];
    const flagSettingPageFlag = featureFlag[myconst.FEATURE_FLAG_KEY.flagSetting];
    const flagPage = flagSettingPageFlag !== undefined ? flagSettingPageFlag ? true : false : true
    const permissionLocal: any = localStorage.getItem("permissions")
    const permission: any = JSON.parse(permissionLocal);
    const roleManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.role);
    const groupManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.group);
    const announcementsManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.announcements);
    const userManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.user);
    const dashboardManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.dashboard);
    const uploadDocManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.uploadDoc);
    const permissionManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.permissions);
    const flagSettingsManagementObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.flagSettings);
    const docApprovalObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.docApproval);
    const blackListedObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.black_listed_word);
    const scrapperObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.scrapper);
    const configurationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.configuration);
    const botConfigurationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.bot_configuration);
    const conversationHistory = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.conversationHistory);
    const InventoryForecastConfigurationObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.inventoryForecastConfiguration);
    const sftpObject = permission?.find((item: any) => item.key === myconst.PERMISSION_KEY.sftp);
    const adminArray = [roleManagementObject?.permissions?.view, groupManagementObject?.permissions?.view, announcementsManagementObject?.permissions?.view, userManagementObject?.permissions?.view, dashboardManagementObject?.permissions, permissionManagementObject?.permissions, flagSettingsManagementObject?.permissions, docApprovalObject?.permissions]
    const adminShow = adminArray.some((a) => a === true)

    const [isCollapsed, setIsCollapsed] = useState(true);
    const [isExpanded, setIsExpanded] = useState(false);
    const [selectedCity, setSelectedCity] = useState(myconst.userControlClass.includes(temp[1]) ? true : false);
    const [selectedData, setSelectedData] = useState(myconst.dataCollectorClass.includes(temp[1]) ? true : false);
    const [dashboardHover, setDashboardHover] = useState(adminDashboard);
    const [announcementsHover, setAnnouncementsHover] = useState(adminAnnouncements);
    const [conversationHistoryHover, setConversationHistoryHover] = useState(adminConversationHistory);
    const [userHover, setadminUserHover] = useState(adminUser);
    const [docApprovalHover, setdocApprovalHover] = useState(adminDocApproval);
    const [flagHover, setFlagHover] = useState(adminFlag);
    const [configurationHover, setConfigurationHoverHover] = useState(adminConfiguration);
    const [blackListedHover, setBlackListedHover] = useState(adminBlackListed);
    const [dataCollecterHover, setDataCollecterHover] = useState(adminDataCollector);
    const [botConfigurationHover, setBotConfigurationHover] = useState(adminBotConfiguration);
    const [inventoryForecastConfigurationHover, setInventoryForecastConfigurationHover] = useState(ForecastConfigurationIcon)
    // const [isActive, setActive] = useState<boolean>(false);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
        setIsExpanded(true);
    };

    const toogleFunction = (state: boolean) => {
        if (state === true && !isActive) {
            // if (selectedCity === true && isCollapsed === false) {
            return "sidebar-nav collapse inner-menu show"
        } else {
            return "sidebar-nav collapse inner-menu"
        }
    }

    useEffect(() => {
        const adminIcon: any = document.getElementById("down_user");
        // if (selectedCity === true) {
        if (selectedCity && adminIcon !== null && typeof adminIcon !== 'undefined') {
            adminIcon.style.transform = "rotate(180deg)"
            adminIcon.style.transition = "ease 0.5s"
        } else if (adminIcon !== null && typeof adminIcon !== 'undefined') {
            adminIcon.style.transform = "rotate(0deg)"
            adminIcon.style.transition = "ease 0.5s"
        }
        // }

    }, [selectedCity])

    useEffect(() => {
        const adminIcon: any = document.getElementById("down_data");
        // if (selectedCity === true) {
        if (selectedData && adminIcon !== null && typeof adminIcon !== 'undefined') {
            adminIcon.style.transform = "rotate(180deg)"
            adminIcon.style.transition = "ease 0.5s"
        } else if (adminIcon !== null && typeof adminIcon !== 'undefined') {
            adminIcon.style.transform = "rotate(0deg)"
            adminIcon.style.transition = "ease 0.5s"
        }
        // }

    }, [selectedData])

    const overFunction = () => {
        if (selectedCity === true) {
            setIsCollapsed(false);
        }
    }

    const handleToggleSidebar = (): void => {
        setActive(!isActive);
    };

    const [isToggled, setIsToggled] = useState(false);
    const handleToggle = () => {
        setIsToggled(!isToggled);
    };
    const styleNew = {
        transform: isToggled ? 'translateX(0)' : ''
    };

    return (
        <div id="wrapper" onClick={() => oh.current.hide()}>
            <span onClick={handleToggle} className='pi pi-bars meu-toggle'></span>
            {/* className={menuOpen}  */}
            {/* <div id="wrapper" className={(menuToggle) ? "sidebar--open" : ""}  > */}
            <aside id="sidebar-wrapper" ref={sidebarRef} className={isActive ? "sidebar-sm" : undefined} style={styleNew} onClick={handleToggle}>
                {/* onMouseOver={() => { setMenuOpen(""); setDisplay("fa fa-chevron-down "); overFunction(); }} onMouseOut={() => { setMenuOpen(hoverFunction); setDisplay("d-none"); setIsCollapsed(true); }} */}

                <span className='sidebar-drawer-arrow' onClick={handleToggleSidebar}>
                    <img src={sidebarDrawerArrow} alt="Sidebar Drawer Arrow" />
                </span>
                <ul className="sidebar-nav">
                    {dashboardManagementObject?.permissions &&
                        <li className={temp[1] === 'dashboard' ? "active" : ""} onClick={() => { setSelectedCity(false); setSelectedData(false); }}>
                            <Link to="/admin/dashboard" onMouseEnter={() => setDashboardHover(adminDashboardHover)} onMouseLeave={() => setDashboardHover(adminDashboard)} title={isActive ? 'Dashboard' : ""}>
                                {/* <i className="pi pi-th-large"></i> */}
                                <i><img src={temp[1] === 'dashboard' ? adminDashboardHover : dashboardHover} alt="Dashboard" /></i>
                                <span>Dashboard</span></Link>
                        </li>
                    }
                    {announcementsManagementObject?.permissions?.view &&
                        <li className={temp[1] === 'announcements' ? "active" : ""} onClick={() => { setSelectedCity(false); setSelectedData(false); }}>
                            <Link to="/admin/announcements" onMouseEnter={() => setAnnouncementsHover(adminAnnouncementsHover)} onMouseLeave={() => setAnnouncementsHover(adminAnnouncements)} title={isActive ? 'Announcements' : ""}>
                                {/* <i className="pi pi-bell"></i> */}
                                <i><img src={temp[1] === 'announcements' ? adminAnnouncementsHover : announcementsHover} alt="Announcements" /></i>
                                <span>Announcements</span>
                            </Link>
                        </li>
                    }
                    {(groupManagementObject?.permissions?.view || userManagementObject?.permissions?.view || roleManagementObject?.permissions?.view || permissionManagementObject?.permissions) &&
                        <li className={`d-flex align-items-center justify-content-between c-pointer ${myconst.userControlClass.includes(temp[1]) ? "active sub-menu-active" : ""}`} id='user_management' onClick={() => {
                            if (isActive) {
                                setActive(false);
                                setSelectedCity(true);
                                setSelectedData(false);
                            } else { setSelectedCity(!selectedCity); setSelectedData(false); }
                        }}>
                            {/* <li data-bs-toggle="collapse" className={`d-flex align-items-center justify-content-between c-pointer ${myconst.userControlClass.includes(temp[1]) ? "active" : ""}`} id='user_management' data-bs-target="#multiCollapseExample3" aria-expanded="false" aria-controls="multiCollapseExample2"> */}
                            <a onMouseEnter={() => setadminUserHover(adminUserHover)} onMouseLeave={() => setadminUserHover(adminUser)} title={isActive ? 'User Control' : ""}>
                                {/* <i className="pi pi-user-plus"></i> */
                                    <i><img src={myconst.userControlClass.includes(temp[1]) ? adminUserHover : userHover} alt="User" /></i>}
                                <span>User Control</span>
                            </a>
                            <i className="fa fa-chevron-down" id='down_user'></i>
                        </li>
                    }
                    <ul className={toogleFunction(selectedCity)} id="multiCollapseExample3">

                        {groupManagementObject?.permissions?.view && (
                            <li className={temp[1] === "groups" ? "active" : ""}>
                                <Link to="/admin/groups">
                                    {/* <i className="fa-solid fa-people-group"></i>  */}
                                    <span>Groups</span>
                                </Link>
                            </li>
                        )}
                        {userManagementObject?.permissions?.view && (
                            <li className={temp[1] === 'users' ? "active" : ""}>
                                <Link to="/admin/users">
                                    {/* <i className="pi pi-users"></i> */}
                                    <span>Users</span>
                                </Link>
                            </li>
                        )}
                        {roleManagementObject?.permissions?.view && (
                            <li className={temp[1] === "roles" ? "active" : ""}>
                                <Link to="/admin/roles">
                                    {/* <i className="fa-solid fa-people-line"></i> */}
                                    <span>Roles</span>
                                </Link>
                            </li>
                        )}
                        {permissionManagementObject?.permissions &&
                            <li className={temp[1] === 'permission' ? "active" : ""}>
                                <Link to="/admin/permission">
                                    {/* <i className="fa-solid fa-user-lock"></i> */}
                                    <span>Permission</span></Link>
                            </li>
                        }
                    </ul>
                    {docApprovalObject?.permissions &&
                        <li className={temp[1] === 'doc-approval' ? "active" : ""} onClick={() => { setSelectedCity(false); setSelectedData(false); }}>
                            <Link to="/admin/doc-approval" onMouseEnter={() => setdocApprovalHover(adminDocApprovalHover)} onMouseLeave={() => setdocApprovalHover(adminDocApproval)} title={isActive ? 'Doc Approval' : ""}>
                                {/* <i className="fa-regular fa-file-lines"></i> */}
                                <i><img src={temp[1] === 'doc-approval' ? adminDocApprovalHover : docApprovalHover} alt="Doc Approval" /></i>
                                <span>Doc Approval</span>
                            </Link>
                        </li>
                    }
                    {flagSettingsManagementObject?.permissions && flagPage &&
                        <li className={temp[1] === 'flag-settings' ? "active" : ""} onClick={() => { setSelectedCity(false); setSelectedData(false); }}>
                            <Link to="/admin/flag-settings" onMouseEnter={() => setFlagHover(adminFlagHover)} onMouseLeave={() => setFlagHover(adminFlag)} title={isActive ? 'Flag Settings' : ""}>
                                {/* <i className="pi pi-cog"></i> */}
                                <i><img src={temp[1] === 'flag-settings' ? adminFlagHover : flagHover} alt="flag" /></i>
                                <span>Flag Settings</span>
                            </Link>
                        </li>
                    }
                    {configurationObject?.permissions &&
                        <li className={temp[1] === 'configuration' ? "active" : ""} onClick={() => { setSelectedCity(false); setSelectedData(false); }}>
                            <Link to="/admin/configuration" onMouseEnter={() => setConfigurationHoverHover(adminConfigurationHover)} onMouseLeave={() => setConfigurationHoverHover(adminConfiguration)} title={isActive ? 'Configuration' : ""}>
                                {/* <i className="fa-solid fa-user-gear"></i> */}
                                <i><img src={temp[1] === 'configuration' ? adminConfigurationHover : configurationHover} alt="configuration" /></i>
                                <span>Configuration</span>
                            </Link>
                        </li>
                    }
                    {blackListedObject?.permissions &&
                        <li className={temp[1] === 'black-listed-words' ? "active" : ""} onClick={() => { setSelectedCity(false); setSelectedData(false); }}>
                            <Link to="/admin/black-listed-words" onMouseEnter={() => setBlackListedHover(adminBlackListedHover)} onMouseLeave={() => setBlackListedHover(adminBlackListed)} title={isActive ? 'Black Listed' : ""}>
                                {/* <i className="fa-regular fa-file-lines"></i> */}
                                <i><img src={temp[1] === 'black-listed-words' ? adminBlackListedHover : blackListedHover} alt="Black Listed" /></i>
                                <span>Black Listed</span></Link>
                        </li>
                    }
                    {/* {
                        <li className={temp[1] === 'voice-upload' ? "active" : ""}>
                            <Link to="/voice-upload">
                                <i className="fa-regular fa-file-lines"></i>
                                <span>voice-upload</span> </Link>
                        </li>
                    } */}
                    {(scrapperObject?.permissions) &&
                        <li onClick={() => { if (isActive) { setActive(false); setSelectedCity(false); setSelectedData(true); } else { setSelectedCity(false); setSelectedData(!selectedData); } }} className={`d-flex align-items-center justify-content-between c-pointer ${myconst.dataCollectorClass.includes(temp[1]) ? "active sub-menu-active" : ""}`} id='admin'>
                            <a onMouseEnter={() => setDataCollecterHover(adminDataCollectorHover)} onMouseLeave={() => setDataCollecterHover(adminDataCollector)} title={isActive ? 'Data Collector' : ""}>
                                {/* <i className="fa-solid fa-link"></i> */}
                                <i><img src={myconst.dataCollectorClass.includes(temp[1]) ? adminDataCollectorHover : dataCollecterHover} alt="Data Collecter" /></i>
                                <span>Data Collector</span>
                            </a>
                            <i className="fa fa-chevron-down" id='down_data'></i>
                        </li>
                    }
                    <ul className={toogleFunction(selectedData)} id="multiCollapseExample2">
                        {/* <li className={temp[1] === 'web-scrapper' ? "active" : ""}> */}
                        {scrapperObject?.permissions &&
                            <li className={temp[1] === 'web-scrapper' ? "active" : ""}>
                                <Link to="/admin/web-scrapper">
                                    {/* <i className="fa-solid fa-database"></i> */}
                                    <span>Web Scrapper</span>
                                </Link>
                            </li>
                        }
                        {/* <li className={temp[1] === 'bot-scrapper' ? "active" : ""}>
                            <Link to="/admin/bot-scrapper" onMouseEnter={() => setInventoryForecastConfigurationHover(ForecastConfigurationHoverIcon)} onMouseLeave={() => setInventoryForecastConfigurationHover(ForecastConfigurationIcon)} title={isActive ? 'Bot Scrapper Configuration' : ""}>
                                <span>Bot Scrapper</span>
                            </Link>
                        </li> */}
                    </ul>
                    {botConfigurationObject?.permissions &&
                        <li className={temp[1] === 'bot-configuration' ? "active" : ""} onClick={() => { setSelectedCity(false); setSelectedData(false); }}>
                            <Link to="/admin/bot-configuration" onMouseEnter={() => setBotConfigurationHover(adminBotConfigurationHover)} onMouseLeave={() => setBotConfigurationHover(adminBotConfiguration)} title={isActive ? 'Bot Configuration' : ""}>
                                {/* <i className="fa-solid fa-user-gear"></i> */}
                                <i><img src={temp[1] === 'bot-configuration' ? adminBotConfigurationHover : botConfigurationHover} alt="Bot Configuration" /></i>
                                <span>Bot Configuration</span></Link>
                        </li>
                    }
                    {conversationHistory?.permissions &&
                        <li className={temp[1] === 'conversation-history' ? "active" : ""} onClick={() => { setSelectedCity(false); setSelectedData(false); }}>
                            <Link to="/admin/conversation-history" onMouseEnter={() => setConversationHistoryHover(adminConversationHistoryHover)} onMouseLeave={() => setConversationHistoryHover(adminConversationHistory)} title={isActive ? 'Conversation History' : ""}>
                                {/* <i className="pi pi-bell"></i> */}
                                <i><img src={temp[1] === 'conversation-history' ? adminConversationHistoryHover : conversationHistoryHover} alt="Conversation History" /></i>
                                <span>Conversation History</span>
                            </Link>
                        </li>
                    }
                    {/* <li className={temp[1] === 'graph' ? "active" : ""} onClick={() => { setSelectedCity(false); setSelectedData(false); }}>
                        <Link to="/admin/graph" onMouseEnter={() => setConversationHistoryHover(adminConversationHistoryHover)} onMouseLeave={() => setConversationHistoryHover(adminConversationHistory)} title={isActive ? 'Graph' : ""}>
                            <i><img src={temp[1] === 'conversation-history' ? adminConversationHistoryHover : conversationHistoryHover} alt="Graph" /></i>
                            <span>Graph</span>
                        </Link>
                    </li> */}
                    {/* <li className={temp[1] === 'butter-pie' ? "active" : ""} onClick={() => { setSelectedCity(false); setSelectedData(false); }}>
                        <Link to="/admin/butter-pie" onMouseEnter={() => setConversationHistoryHover(adminConversationHistoryHover)} onMouseLeave={() => setConversationHistoryHover(adminConversationHistory)} title={isActive ? 'Butter Pie' : ""}>
                            <i><img src={temp[1] === 'butter-pie' ? adminConversationHistoryHover : conversationHistoryHover} alt="Graph" /></i>
                            <span>Butter Pie</span>
                        </Link>
                    </li> */}


                    {/* {InventoryForecastConfigurationObject?.permissions &&
                        <li className={temp[1] === 'inventory-forecast-configuration' ? "active" : ""} onClick={() => { setSelectedCity(false); setSelectedData(false); }}>
                            <Link to="/admin/inventory-forecast-configuration" onMouseEnter={() => setInventoryForecastConfigurationHover(ForecastConfigurationHoverIcon)} onMouseLeave={() => setInventoryForecastConfigurationHover(ForecastConfigurationIcon)} title={isActive ? 'Inventory Configuration' : ""}>

                                <i><img src={temp[1] === 'inventory-forecast-configuration' ? ForecastConfigurationHoverIcon : inventoryForecastConfigurationHover} alt="inventory forecast Configuration" /></i>
                                <span>Inventory Configuration</span>
                            </Link>
                        </li>
                    } */}
                </ul>
            </aside>
        </div>
    )
}

export default Sidebar
